import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { LotClubbingDto } from "./dto/lot-clubbing.dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import appSettings from "apps/services/config";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { QueryRunner,getConnection } from "typeorm";
import { MatserClubbedLots } from "./lot-clubbing.entity";
import { ChildClubbedLots } from "./lot-clubbing-items.entity";
import { DeheadingReportingTypeEnum, FgStatusEnum, GlobalStatus, GlobalVariableValues, JobCompletedEnum, LotClubTypeEnum, operationEntryTypeEnum, OperationTypeEnum, spsaOperationEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { LotCodeOpsEntity } from "../operations-track/entities/lot-code.entity";
import { ProductionLog } from '../operations-track/entities/production-log.entity';
import { ProductionInventory } from '../operations-track/entities/production-inventory.entity';

@Injectable()
export class LotClubbingService {
    constructor(
        // @InjectRepository(ProductConversion)
        // private productConversionRepository: Repository<ProductConversion>,
        // private productConversionAdapter: ProductConversionAdapter,
        // private saleService: SaleOrderService,
    ) { }
    async createLotClubbing(req:LotClubbingDto):Promise<CommonResponse>{
        // const manager = getManager()
        const connection = getConnection();
        const transmanager: QueryRunner = connection.createQueryRunner();
        try{
            await transmanager.startTransaction()
            // let prodInvData
            // const countQry = req.operation == OperationTypeEnum.GRADING ? `output_grade` : `input_grade`
            // if(GlobalVariableValues.productionVersion == 'V1'){
            //     prodInvData = `select prod_inv_id as prodInvId from ${appSettings.production_db}.production_inventory where lot_number = '${req.mainlotNo}' and sale_order_id = ${req.saleOrderId} and sale_order_item_id = ${req.soItemId} and plant_id = ${req.plantId} and sub_plant_id = ${req.subPlantId} and operation = '${req.operation}'`
            // }else{
            //     prodInvData = `select prod_inv_id as prodInvId,out_product as product from ${appSettings.production_db}.production_inventory where lot_number = '${req.mainlotNo}' and plant_id = ${req.plantId} and sub_plant_id = ${req.subPlantId} and operation = '${req.operation}' and prev_operation = '${req.prevOperation}' and entry_type = '${operationEntryTypeEnum.OUT}'`
            //     if(req.count != undefined){
            //         prodInvData += ` and output_grade = ${req.count}`
            //     }
            //     if(req.outCountType != undefined){
            //         prodInvData += ` and out_count_type = '${req.outCountType}'`
            //     }
            // }
    
            // console.log(prodInvData,'prodInvDatajjj')
            // const res = await transmanager.query(prodInvData)

            const lotNumCheck = `SELECT * from ${appSettings.production_db} .production_inventory where lot_number = '${req.newLotNumber}' and year = ${new Date().getFullYear()}`
            const lotNumCheckRes = await transmanager.query(lotNumCheck)

            if(lotNumCheckRes.length > 0){
                await transmanager.rollbackTransaction()
                await transmanager.release()
                return new CommonResponse(false,0,'Lot number already exists')
            }else{
                const getMainLotInfoQry = `select * from ${appSettings.production_db} .production_inventory where prod_inv_id = ${req.prodInvId}`
                const mainLotInfo = await transmanager.query(getMainLotInfoQry)
    
                // if(prodInvData){
                    const clubLotsModel = new MatserClubbedLots() 
                    clubLotsModel.mainLot = req.mainlotNo
                    clubLotsModel.operation = req.operation
                    clubLotsModel.saleOrderId = req.saleOrderId ? req.saleOrderId : 0
                    clubLotsModel.soItemId = req.soItemId ? req.soItemId : 0
                    clubLotsModel.plantId = req.plantId
                    clubLotsModel.subPlantId = req.subPlantId
                    clubLotsModel.purpose = req.purpose
                    clubLotsModel.remarks = req.remarks
                    clubLotsModel.createdUser = req.createdUser
                    clubLotsModel.count = req.count
                    clubLotsModel.qtyAfterClub = req.qtyAftClub
                    clubLotsModel.qtyAvailable = req.availableQuantity
                    clubLotsModel.productionInventoryId = req.prodInvId
                    clubLotsModel.year = req.year
                    clubLotsModel.clubbedQuantity = req.clubbedQuantity
                    clubLotsModel.newLotNumber = req.newLotNumber
                    clubLotsModel.countType = req.newCountType
                    clubLotsModel.newProduct = req.newProduct
                    clubLotsModel.newCount = req.newCount
                    const childLotInfo = []
                    let totQty = 0
                    let totBoxes = 0
                    for(const item of req.subLotInfo){
                        const itemObj = new ChildClubbedLots()
                        itemObj.lotNumber = item.lotNumber
                        itemObj.subLotNumber = item.sublotNumber
                        itemObj.quantity = item.quantity
                        itemObj.createdUser = req.createdUser
                        itemObj.opBoxes = item.opBoxes
                        itemObj.count = item.count
                        itemObj.prodInvId = item.prodInvId
                        itemObj.countType = item.countType
                        itemObj.clubbedQuantity = item.clubbedQuantity
                        itemObj.year = item.year
                        itemObj.lotClubType = Number(item.quantity) - Number(item.clubbedQuantity) == 0 ? LotClubTypeEnum.FULL : LotClubTypeEnum.PARTIAL
                        childLotInfo.push(itemObj)
                        totQty = Number(totQty)+Number(item.quantity)
                        totBoxes = Number(totBoxes)+Number(item.opBoxes)
                    }
                    clubLotsModel.childLotInfo = childLotInfo
                    const saveLog = await transmanager.manager.save(MatserClubbedLots,clubLotsModel);
                    if(saveLog){
                        const tobeupdateval = req.prodInvId
                        let prodInvUpdate
                            const prodSaveFlag = new Set<boolean>()
                            for(let i=1;i<=2;i++){
    
                                const prodInvObj = new ProductionInventory();
                                prodInvObj.lotNumber = req.newLotNumber;
                                prodInvObj.subLotNumber = req.newLotNumber;
                                prodInvObj.operation = OperationTypeEnum.CLUBBING;
                                prodInvObj.prevOperation = req.prevOperation
                                prodInvObj.year = new Date().getFullYear();
                                prodInvObj.inputGrade = String(req.count);
                                prodInvObj.plantId = req.plantId;
                                prodInvObj.subPlantId = req.subPlantId;
                                prodInvObj.boxes = 0
                                prodInvObj.opBoxes =0 
                                prodInvObj.weighmentReq = GlobalStatus.NO;
                                prodInvObj.status = FgStatusEnum.OPEN;
                                prodInvObj.createdUser = req.createdUser;
                                prodInvObj.product = mainLotInfo[0].product
                                prodInvObj.variantId = mainLotInfo[0].variant_id
                                prodInvObj.countType = mainLotInfo[0].count_type
                                if(i == 1){
                                    prodInvObj.entryType = operationEntryTypeEnum.IN
                                    prodInvObj.inputQuantity = req.qtyAftClub
                                }else{
                                    prodInvObj.entryType = operationEntryTypeEnum.OUT
                                    prodInvObj.outCountType = req.newCountType
                                    prodInvObj.outProduct = req.newProduct
                                    prodInvObj.physicalQuantity = req.qtyAftClub
                                    prodInvObj.outputGrade = req.newCount
    
                                }
                                // prodInvObj.minGrade = res[0].min_grade
                                // prodInvObj.maxGrade = res[0].max_grade
        
                                const prodInvResponse = await transmanager.manager.getRepository(ProductionInventory).save(prodInvObj);
                                console.log(prodInvResponse,'prodInvResponse')
                                if(prodInvResponse){
                                    prodSaveFlag.add(true)
                                    // job number generation 
                                        let today = new Date();
                                        let CurrentYear = today.getFullYear();
                                        let CurrentMonth = today.getMonth();
                                        let fromDate = 0;
                                        let toDate = 0;
                                        let totalRecords = await (await transmanager.manager.getRepository(ProductionLog).find({ where: { operationType: OperationTypeEnum.CLUBBING } })).length
                                    //    let totalRecords = await (await this.logRepository.find({ where: { operationType: req.operation } })).length;
                                    console.log(totalRecords,'totalRecords')
            
                                        if (CurrentMonth < 4) {
                                            fromDate = (CurrentYear-1);
                                            toDate = (CurrentYear);
                                        } else {
                                            fromDate = (CurrentYear);
                                            toDate = (CurrentYear + 1);
                                        }
            
                                        totalRecords = totalRecords + 1;
            
                                    var refNo = totalRecords + "";
                                    while (refNo.length < 4) refNo = "0" + refNo;
                            
                                    const grnJobNo = 'CLUB' + "/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
                            
                                    // Create Log
                                    const productionLogObj = new ProductionLog();
                                    productionLogObj.lotNumber = req.newLotNumber;
                                    productionLogObj.subLotNumber = req.newLotNumber;
                                    productionLogObj.operationType = OperationTypeEnum.CLUBBING;
                                    productionLogObj.jobNumber = grnJobNo;
                                    productionLogObj.plantId = req.plantId;
                                    productionLogObj.prevOperation = req.prevOperation
                                    // productionLogObj.plantLotNumber=grnDto.remarks;
                                    if (req.subPlantId) {
                                    productionLogObj.subPlantId = req.subPlantId;
                                    productionLogObj.workStationType = WorkStationTypeEnum.EXTERNAL;
                                    }
                                    productionLogObj.jobStatus = JobCompletedEnum.NO;
                                    productionLogObj.inputGrade = String(req.count);
                                    productionLogObj.inputBoxes = totBoxes;
                                    productionLogObj.assignedUser = req.createdUser;
                                    productionLogObj.createdUser = req.createdUser;
                                    productionLogObj.prodInvId = prodInvResponse.productionInventoryId;
                                    productionLogObj.product = mainLotInfo[0].product
                                    productionLogObj.variantId = mainLotInfo[0].variant_id
                                    productionLogObj.countType = mainLotInfo[0].count_type
                                    productionLogObj.year =  new Date().getFullYear();
                                    productionLogObj.date = new Date()
    
                                    if(i == 1){
                                        productionLogObj.entryType = operationEntryTypeEnum.IN
                                        productionLogObj.inputQuantity = req.qtyAftClub
                                        productionLogObj.outReportingType = DeheadingReportingTypeEnum.FULL
                                    }else{
                                        productionLogObj.entryType = operationEntryTypeEnum.OUT
                                        productionLogObj.actualOutputQuantity = req.qtyAftClub;
                                        productionLogObj.outCountType = req.newCountType
                                        productionLogObj.outProduct = req.newProduct
                                        productionLogObj.actualGrade = req.newCount
                                        
                                    }
                                //    productionLogObj.minGrade = res[0].min_grade
                                //    productionLogObj.maxGrade = res[0].max_grade
                                    const createLog = await transmanager.manager.getRepository(ProductionLog).save(productionLogObj);
                                    if(createLog){
                                        prodSaveFlag.add(true)
                                    }else{
                                        prodSaveFlag.add(false)
                                        await transmanager.rollbackTransaction()
                                        await transmanager.release()
                                        return new CommonResponse(false,0,'Something went wrong in saving production log info')
                                    }
                                    
                                }else{
                                    prodSaveFlag.add(false)
                                    await transmanager.rollbackTransaction()
                                    await transmanager.release()
                                    return new CommonResponse(false,0,'Something went wrong in saving production inventory info')
                                }
                            }
                        if(!(prodSaveFlag.has(false))){
                            if(clubLotsModel.operation == OperationTypeEnum.GRN){
                                prodInvUpdate = await transmanager.manager.update('production_inventory',{productionInventoryId:tobeupdateval},{physicalQuantity:()=>`physical_quantity - ${req.clubbedQuantity}`})
                            }
                            else if(clubLotsModel.operation == OperationTypeEnum.VALUE_ADDITION){
                                prodInvUpdate = await transmanager.manager.update('production_inventory',{productionInventoryId:tobeupdateval},{wipQuantity :()=>`wip_quantity - ${req.clubbedQuantity}`})
                            }
                            else{
                                prodInvUpdate = await transmanager. manager.update('production_inventory',{productionInventoryId:tobeupdateval},{clubbedQuantity:()=>`clubbed_quantity + ${req.clubbedQuantity}`})
                            }
                        }else{
                        await transmanager.rollbackTransaction()
                        await transmanager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving production log info')
                        }
                        if(prodInvUpdate.affected){
                            let updateFlag = true
                            for(const record of req.subLotInfo){
                                let childLotInvUpdate
                                if(GlobalVariableValues.productionVersion == 'V1'){
                                    childLotInvUpdate = await transmanager.manager.update('production_inventory',{subLotNumber:`${record.sublotNumber}`,operation:req.operation,plantId:`${req.plantId}`,subPlantId :`${req.subPlantId}`},{physicalQuantity:0})
                                } else{
                                    if(clubLotsModel.operation == OperationTypeEnum.VALUE_ADDITION){
                                    childLotInvUpdate = await transmanager.manager.update('production_inventory',{productionInventoryId:record.prodInvId},{wipQuantity:0})
                                    }else{
                                        childLotInvUpdate = await transmanager.manager.update('production_inventory',{productionInventoryId:record.prodInvId},{clubbedQuantity: () => `clubbed_quantity + ${record.clubbedQuantity}`})
                                    }
                                }
                                // const childLotInvUpdateQry = `update ${appSettings.production_db}.production_inventory set physical_quantity = 0 where sub_lot_number = ${record.sublotNumber} and plant_id = ${req.plantId} and sub_plant_id = ${req.subPlantId}`
                                // const childLotInvUpdate = await manager.query(childLotInvUpdateQry)
                                if(!(childLotInvUpdate.affected)){
                                    updateFlag = false
                                    break
                                }
                            }
                            if(updateFlag){
                                const updateClubbedLotFlag = new Set<boolean>()
                                const getMianLotAgainstClubbedLot = await transmanager.manager.findOne(LotCodeOpsEntity,{where:{lotNumber:req.mainlotNo},select:['mainLotNum']})
                                // console.log(getMianLotAgainstClubbedLot,'getMianLotAgainstClubbedLot')
                                let updateclubbedLotInfo
                                if(getMianLotAgainstClubbedLot){
                                    updateclubbedLotInfo = await transmanager.manager.update(LotCodeOpsEntity,{lotNumber:req.mainlotNo},{lotClubStatus:true,clubbedMainLot:req.mainlotNo,mainLotAfterClub:getMianLotAgainstClubbedLot.mainLotNum})
                                    if(updateclubbedLotInfo.affected){
                                        for(const rec of req.subLotInfo){
                                            const updateclubbedLotInfoAgainstChildLot = await transmanager.manager.update(LotCodeOpsEntity,{lotNumber:rec.lotNumber},{lotClubStatus:true,clubbedMainLot:req.mainlotNo,mainLotAfterClub:getMianLotAgainstClubbedLot.mainLotNum})
                                            if(updateclubbedLotInfoAgainstChildLot.affected){
                                                updateClubbedLotFlag.add(true)
                                            }else{
                                                updateClubbedLotFlag.add(false)
                                            }
                                        }
                                        if(!updateClubbedLotFlag.has(false)){
                                            await transmanager.commitTransaction()
                                            await transmanager.release()
                                            return new CommonResponse(true,1111,'Lot clubbed successfully')
                                        }else{
                                            await transmanager.rollbackTransaction()
                                            await transmanager.release()
                                            return new CommonResponse(false,0,'Something went wrong ')
                                        }
                                    }
                                }else{
                                    await transmanager.commitTransaction()
                                    await transmanager.release()
                                    return new CommonResponse(true,1111,'Lot clubbed successfully')
                                }
                            }else{
                                await transmanager.rollbackTransaction()
                                await transmanager.release()
                                return new CommonResponse(false,1111,'something went wrong in lo saving')
                            }
                        }else{
                            await transmanager.rollbackTransaction()
                            await transmanager.release()
                            return new CommonResponse(false,1111,'something went wrong in Inventory Update')
                        }
                    }else{
                        await transmanager.rollbackTransaction()
                        await transmanager.release()
                        return new CommonResponse(false,1111,'something went wrong in lo saving')
                    }
            }
        }catch(err){
            console.log(err,'errrrrrrrrrrrrrrrr')
            await transmanager.rollbackTransaction()
            await transmanager.release()
            return new CommonResponse(false,1111,'Something went wrong',err)

        }
    }
}